module.exports = __webpack_public_path__ + "img/google.e71e3885.svg";